{
  "nl": {
    "button": {
      "actions": {
        "add": "Voeg toe",
        "cancel": "Annuleren",
        "close": "Sluit",
        "copyEmail": "Kopieer e-mail",
        "create": "Maak aan",
        "delete": "Verwijderen",
        "display": "Weergave",
        "edit": "Bewerken",
        "hide": "Verberg",
        "loading": "Laden",
        "more": "Meer acties",
        "move": "Verplaats",
        "move_down": "Omlaag verplaatsen",
        "move_up": "Omhoog verplaatsen",
        "no": "Nee",
        "reactivateEmailAddress": "E-mailadres opnieuw activeren",
        "reset": "Reset",
        "save": "Opslaan",
        "save_changes": "Wijzigingen opslaan",
        "save_message": "Bericht opslaan",
        "saving": "Opslaan",
        "share": "Deel",
        "startTour": "Start rondleiding",
        "uploadingDocuments": "Opladen documenten",
        "yes": "Ja"
      }
    }
  }
}
